"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContent = void 0;
var Utilities_1 = require("../../Utilities");
var DialogContent_base_1 = require("./DialogContent.base");
var DialogContent_styles_1 = require("./DialogContent.styles");
exports.DialogContent = (0, Utilities_1.styled)(DialogContent_base_1.DialogContentBase, DialogContent_styles_1.getStyles, undefined, { scope: 'DialogContent' });
exports.DialogContent.displayName = 'DialogContent';
//# sourceMappingURL=DialogContent.js.map